// Soft elevation of cards and panels.
export const shadow = {
  card: '0 1px 3px rgba(15,23,42,0.04), 0 1px 2px rgba(15,23,42,0.02)',
}
